import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-update-success',
  standalone: true,
  imports: [MatDialogModule,CommonModule],
  templateUrl: './update-success.component.html',
  styleUrl: './update-success.component.scss'
})
export class UpdateSuccessComponent {
  message: string = ""
  title:string=""
  action:string=""
  actionType: string="add"
  cancelButtonText = "Cancel"
  constructor(
    @Inject(MAT_DIALOG_DATA) private data: any,
    private dialogRef: MatDialogRef<UpdateSuccessComponent>) {
    if (data) {
      this.message = data.message;
      this.title= data.title;
      this.action = data.actionType
    }
    this.dialogRef.updateSize('300vw','300vw')
  }

  onConfirmClick(): void {
    this.dialogRef.close(true);
  }
}
